<template>
  <PageArticle />
</template>

<script setup lang="ts">
definePageMeta({
  scrollToTop: true,
});
</script>

<style scoped lang="postcss"></style>
